module.exports = __webpack_public_path__ + "static/6-5f527be957f6c24499d84f7c133e1ec7.wav";